import React from 'react';
import styled from 'styled-components';
import { boxShadows, colors } from '@99designs/emu/settings';
import { IconLeft4, IconRight4 } from '@99designs/icons';

interface Props {
    onClick: () => void;
    disabled: boolean;
    className?: string;
}

export const buttonHoverColor = 'rgba(49, 48, 48, 0.4)';

const StyledButton = styled.button`
    height: 110px;
    width: 55px;
    z-index: 2;
    border: none;
    font-size: 1.5em;
    color: ${colors.white};
    background-color: rgba(49, 48, 48, 0.2);
    transition: all 250ms ease-in-out;
    outline: none;

    &[disabled] {
        opacity: 0;
    }

    &:focus-visible {
        outline: none;
        background-color: ${buttonHoverColor};
        &::after {
            content: '';
            position: absolute;
            border-radius: inherit;
            top: -2px;
            right: -2px;
            bottom: -2px;
            left: -2px;
            box-shadow: ${boxShadows.focusRing};
            z-index: 1;
            pointer-events: none;
        }
    }
`;

const StyledLeftButton = styled(StyledButton)`
    border-bottom-right-radius: 55px;
    border-top-right-radius: 55px;
`;

const StyledRightButton = styled(StyledButton)`
    border-bottom-left-radius: 55px;
    border-top-left-radius: 55px;
`;

export const LeftButton = ({ onClick, disabled, ...props }: Props) => (
    <StyledLeftButton
        type="button"
        onClick={onClick}
        disabled={disabled}
        aria-label={__('scroll left')}
        {...props}
    >
        <IconLeft4 />
    </StyledLeftButton>
);

export const RightButton = ({ onClick, disabled, ...props }: Props) => (
    <StyledRightButton
        type="button"
        onClick={onClick}
        disabled={disabled}
        aria-label={__('scroll right')}
        {...props}
    >
        <IconRight4 />
    </StyledRightButton>
);
